export enum DocumentTypeEnum {
  TRANSCRIPT = 'transcript',
  ACTION_PLAN = 'actionPlan',
  DECISION = 'decision',
}
